import commonLocaleConfig from "./translation/common.locale.config";
import errorsLocaleConfig from "./translation/errors.locale.config";

export enum SupportedLanguage {
  en = "en",
  id = "id",
}

export type Locale = {
  [key in SupportedLanguage]: string;
};

const localeConfig: Locale[] = [...commonLocaleConfig, ...errorsLocaleConfig];

export default localeConfig;
